import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Grid, cssOverflowEllipsis } from 'views/anyguide/messages/styles';
import { Theme } from 'ui_system/theme';
import {
  Error as Err,
  FieldSection as FieldSec,
} from 'views/anyguide/resources/formStyles';

import smileysPeopleActiveSvg from 'ui_system/forms/images/smileys_people_active.svg';
import smileysPeopleSvg from 'ui_system/forms/images/smileys_people.svg';
import animalNatureActiveSvg from 'ui_system/forms/images/animal_nature_active.svg';
import animalNatureSvg from 'ui_system/forms/images/animal_nature.svg';
import foodDrinkActiveSvg from 'ui_system/forms/images/food_drink_active.svg';
import foodDrinkSvg from 'ui_system/forms/images/food_drink.svg';
import travelPlacesActiveSvg from 'ui_system/forms/images/travel_places_active.svg';
import travelPlacesSvg from 'ui_system/forms/images/travel_places.svg';
import activitiesActiveSvg from 'ui_system/forms/images/activities_active.svg';
import activitiesSvg from 'ui_system/forms/images/activities.svg';
import objectsActiveSvg from 'ui_system/forms/images/objects_active.svg';
import objectsSvg from 'ui_system/forms/images/objects.svg';
import sybmolsActiveSvg from 'ui_system/forms/images/symbols_active.svg';
import sybmolsSvg from 'ui_system/forms/images/symbols.svg';
import flagsActiveSvg from 'ui_system/forms/images/flags_active.svg';
import flagsSvg from 'ui_system/forms/images/flags.svg';

const defaultColor = (color) =>
  color || Theme.colors.linksDesignElementsBaseColor;

export const Form = styled('div')`
  text-align: left;
  margin: 0 auto;
  max-width: 478px;
  padding: 50px 20px 80px;
`;

export const Box = styled('div')`
  padding: ${(props) => (props.padding ? props.padding : '0')};
`;

export const FormSection = styled('div')`
  margin-bottom: ${Theme.forms.margins.sectionBottom}px;
  /* padding-bottom: ${(props) => (props.last ? '0px' : '25px')}; */
  border-bottom: ${(props) => (props.last ? '0px' : '1px')} solid
    ${Theme.colors.lightLine};
  font-size: 14px;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    font-size: 13px;
  }
`;

export const FieldSection = styled(FieldSec)`
  margin-bottom: ${(props) =>
    props.marginBottom
      ? `${props.marginBottom}px`
      : `${Theme.forms.margins.sectionBottom}px`};
  div:first-letter {
    text-transform: uppercase;
  }
`;

export const EmojiPickerSection = styled('div')`
  position: relative;
  width: 66%;
  left: 33%;
`;

export const EmojiPickerPopUp = styled('div')`
  position: absolute;
  margin-top: -1%;
`;

export const CustomStyledWrapper = styled('div')`
  .emoji-picker-react .emoji-group:before {
    color: #6a6e7c;
    font-size: 11px;
  }

  .emoji-picker-react input.emoji-search {
    border-color: #888ca5;
  }

  .emoji-picker-react .emoji-categories button {
    opacity: 1;
  }

  .emoji-picker-react .emoji-categories button.icn-smileys_people.active {
    background-image: url(${smileysPeopleActiveSvg});
    transition: background-image 0.3s ease;
  }

  .emoji-picker-react .emoji-categories button.icn-smileys_people {
    background-image: url(${smileysPeopleSvg});
  }

  .emoji-picker-react .emoji-categories button.icn-animals_nature.active {
    background-image: url(${animalNatureActiveSvg});
    transition: background-image 0.3s ease;
  }

  .emoji-picker-react .emoji-categories button.icn-animals_nature {
    background-image: url(${animalNatureSvg});
  }

  .emoji-picker-react .emoji-categories button.icn-food_drink.active {
    background-image: url(${foodDrinkActiveSvg});
    transition: background-image 0.3s ease;
  }

  .emoji-picker-react .emoji-categories button.icn-food_drink {
    background-image: url(${foodDrinkSvg});
  }

  .emoji-picker-react .emoji-categories button.icn-travel_places.active {
    background-image: url(${travelPlacesActiveSvg});
    transition: background-image 0.3s ease;
  }

  .emoji-picker-react .emoji-categories button.icn-travel_places {
    background-image: url(${travelPlacesSvg});
  }

  .emoji-picker-react .emoji-categories button.icn-activities.active {
    background-image: url(${activitiesActiveSvg});
    transition: background-image 0.3s ease;
  }

  .emoji-picker-react .emoji-categories button.icn-activities {
    background-image: url(${activitiesSvg});
  }

  .emoji-picker-react .emoji-categories button.icn-objects.active {
    background-image: url(${objectsActiveSvg});
    transition: background-image 0.3s ease;
  }

  .emoji-picker-react .emoji-categories button.icn-objects {
    background-image: url(${objectsSvg});
  }

  .emoji-picker-react .emoji-categories button.icn-symbols.active {
    background-image: url(${sybmolsActiveSvg});
    transition: background-image 0.3s ease;
  }

  .emoji-picker-react .emoji-categories button.icn-symbols {
    background-image: url(${sybmolsSvg});
  }

  .emoji-picker-react .emoji-categories button.icn-flags.active {
    background-image: url(${flagsActiveSvg});
    transition: background-image 0.3s ease;
  }

  .emoji-picker-react .emoji-categories button.icn-flags {
    background-image: url(${flagsSvg});
  }
`;

export const NicknameFieldSection = styled(FieldSection)`
  position: relative;
`;

export const EmojiPickerComponent = styled.img`
  position: relative;
  z-index: 9999;
  left: 93%;
  bottom: 22px;
  width: 25px;
  top: 50%; /* Adjust the top value as needed */
  transform: translateY(-50%);
  cursor: pointer;
  margin-bottom: -25px;
`;

export const FormContainerWithoutPadding = styled.div`
  max-width: 480px;
  box-sizing: content-box;
  margin: 0 auto;
`;

export const FormContainer = styled(FormContainerWithoutPadding)`
  padding: 50px 15px;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    padding-top: 30px;
    padding-bottom: 100px;
  }
`;

export const Label = styled.label`
  font-family: 'soleil', sans-serif;
  font-style: normal;
  color: ${Theme.colors.primaryTextColor};
  font-size: 1.6rem;
  vertical-align: middle;
  font-weight: ${(props) => props.fontWeight || 600};
  display: ${(props) => (props.block ? 'block' : 'inline-block')};
  ${(props) => props.maxWidth && `max-width: ${props.maxWidth};`};
  margin: 0 0 ${Theme.forms.margins.labelBottom}px;
  text-align: ${(props) => (props.center ? 'center' : 'left')};
  ${(props) => !props.allowWrap && cssOverflowEllipsis}
  &:first-letter {
    text-transform: uppercase;
  }
  span:first-letter {
    text-transform: uppercase;
  }
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    font-size: 1.5rem;
  }
`;

export const SubLabel = styled(Label)`
  font-size: 14px;
  color: ${Theme.colors.secondaryTextColor};
  line-height: 150%;
  margin-bottom: ${Theme.forms.margins.labelBottom}px;
  white-space: normal;
  font-weight: 400;
  padding-bottom: 16px;
  width: ${(props) => (props.width ? `${props.width}%` : 'initial')};
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    font-size: 13px;
  }
`;

export const SubLabelWarning = styled(SubLabel)`
  margin-top: 5px;
`;

export const CapLabel = styled(Label)`
  text-transform: uppercase;
  display: block;
  margin-bottom: ${(props) =>
    props.marginBottom ? `${props.marginBottom}px` : '20px'};
  white-space: normal;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    margin-bottom: ${Theme.forms.margins.capLabelBottom}px;
  }
`;

export const SideLabel = styled(Label)`
  font-size: 15px;
  color: ${Theme.colors.secondaryTextColor};
  font-weight: normal;
  margin: auto 10px;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    font-size: 13px;
    white-space: normal;
  }
`;

export const Text = styled('div')`
  font-size: ${(props) => (props.small ? '14px' : '16px')};
  padding-bottom: ${(props) =>
    props.paddingBottom ? `${props.paddingBottom}px` : '0px'};
  color: ${(props) =>
    props.light
      ? Theme.colors.secondaryTextColor
      : Theme.colors.primaryTextColor};
  display: ${(props) => (props.block ? 'block' : 'inline-block')};
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const Subtext = styled('div')`
  font-family: 'soleil', sans-serif;
  font-weight: 400;
  font-style: normal;
  color: ${Theme.colors.secondaryTextColor};
`;

export const Input = styled('input')`
  display: inline-block;
  width: 100%;
  padding: 14px 15px;
  box-sizing: border-box;
  border: 1px solid ${Theme.colors.borderActionableFieldColor};
  border-radius: 0;
  font-size: 1.4rem;
  line-height: 100%;
  background: #fff;
  &:focus {
    outline: none;
  }
`;

export const SectionTitle = styled('div')`
  margin-bottom: 20px;
  text-transform: uppercase;
  font-size: 16px;
  font-weight: 600;
`;

export const Section = styled('div')`
  margin-bottom: 15px;
`;

export const SubmitButton = styled('button')`
  background-color: ${(props) => defaultColor(props.brandColor)};
  color: white;
  border-radius: ${Theme.forms.buttons.radius}px;
  width: 150px;
  font-size: 16px;
  padding: 10px;
  justify-self: ${(props) => (props.justify ? props.justify : 'right')};
  border: solid 1px ${(props) => defaultColor(props.brandColor)};
  div {
    display: inline-block;
  }
  &:disabled {
    opacity: 0.5;
  }
  &:hover {
    background-color: ${Theme.colors.buttonHoverColor};
  }
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    font-size: 15px;
  }
`;

export const DeleteButton = styled(SubmitButton)`
  background: white;
  color: red;
  padding: 6px 18px;
  width: 140px;
  border-radius: ${Theme.forms.buttons.radius}px;
  border: solid 1px ${Theme.colors.borderActionableFieldColor};
  justify-self: left;
  &:hover {
    background-color: ${Theme.colors.backgroundColor};
  }
`;

export const OkButton = styled(SubmitButton)`
  padding: 6px;
  width: 140px;
  border: none;
  justify-self: end;
  height: ${Theme.forms.dimensions.inputHeight}px;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    width: 100%;
  }
`;
export const CancelButton = styled(OkButton)`
  background: transparent;
  color: ${Theme.colors.secondaryTextColor};
  justify-self: start;
  border: 1px solid ${Theme.colors.borderActionableFieldColor};
  &:hover {
    background-color: ${Theme.colors.backgroundColor};
  }
`;

export const Actions = styled(Grid)`
  margin-top: ${Theme.forms.margins.sectionBottom}px;
  border-top: solid ${(props) => (props.border ? '1px' : '0')} #d9d9d9;
  padding-top: ${(props) => (props.border ? '25px' : '0')};
  grid-gap: ${(props) => (props.gap ? `${props.gap}px` : '15px')};
`;

export const Link = styled('a')`
  color: ${Theme.colors.linksDesignElementsBaseColor};
  cursor: pointer;
  &:hover,
  &:visited {
    color: ${Theme.colors.linksDesignElementsBaseColor};
  }
`;

export const ShowHideRules = styled(Link)`
  margin-top: 5px;
  display: inline-block;
`;

export const VisibleRules = styled('div')`
  margin-bottom: 20px;
`;

export const AddButton = styled('div')`
  text-align: center;
  justify-content: center;
  position: relative;
  border: 1px solid
    ${(props) =>
      props.color ? props.color : Theme.colors.linksDesignElementsBaseColor};
  border-radius: ${Theme.forms.buttons.radius}px;
  min-width: 140px;
  display: block;
  padding: 10px;
  font-size: 16px;
  color: ${(props) =>
    props.color ? props.color : Theme.colors.linksDesignElementsBaseColor};
  height: 44px;
  cursor: pointer;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    font-size: 1.5rem;
  }
  i {
    font-size: 12px;
    margin-right: 6px;
  }
`;

export const WarningMsg = styled('div')`
  background: ${(props) => (props.type === 'error' ? 'red' : 'grey')};
  padding: 5px;
  text-align: center;
  color: white;
  margin-bottom: 10px;
`;

export const Error = styled(Err)`
  margin-top: ${(props) => (props.noMargin ? '0' : '15px')};
`;

export const TextField = css`
  width: 100%;
  padding: 14px 15px;

  height: 44px;
  box-sizing: border-box;
  border: 1px solid ${Theme.colors.inputs.border};
  border-radius: 0px;
  font-size: 14px;
  background: transparent;
  &:focus {
    outline: none;
  }

  &::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: ${Theme.colors.inputs.placeholder};
  }
  &::-moz-placeholder {
    /* Firefox 19+ */
    color: ${Theme.colors.inputs.placeholder};
  }
  &:-ms-input-placeholder {
    /* IE 10+ */
    color: ${Theme.colors.inputs.placeholder};
  }
  &:-moz-placeholder {
    /* Firefox 18- */
    color: ${Theme.colors.inputs.placeholder};
  }
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    font-size: 13px;
  }
`;

export const NicknameTextField = css`
  ${TextField}
  padding-right: 13%;
`;

export const DividingLine = styled('div')`
  border-bottom: 1px solid ${Theme.colors.lightLine};
  margin-top: ${(props) =>
    props.margintop ? `${Theme.forms.margins.sectionBottom}px` : '0px'};
  margin-bottom: ${(props) =>
    props.marginbottom ? `${Theme.forms.margins.sectionBottom}px` : '0px'};
  width: 100%;
`;

export const SectionBarIconWrapper = styled.div``;
export const SectionBarMain = styled.div`
  color: ${Theme.colors.primaryTextColor};
`;
export const SectionBarSide = styled.div`
  white-space: nowrap;
  ${(props) => props.light && `color: ${Theme.colors.primaryTextColor};`}
`;

export const MainWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`;

export const SectionBar = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 10px;
  background-color: ${Theme.colors.backgroundColor};

  margin-bottom: ${(props) =>
    props.marginBottom
      ? `${props.marginBottom}px`
      : `${Theme.forms.margins.sectionBottom}px`};

  a {
    color: ${Theme.colors.linksDesignElementsBaseColor};
    cursor: pointer;
  }

  ${SectionBarIconWrapper} {
    margin-right: 8px;
  }

  ${SectionBarMain} {
    flex-basis: 100%;
  }
`;
